const CloseWidthImage = () => {
	return (
		<svg
			width="14"
			height="13"
			viewBox="0 0 14 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6 7.5V13H4.5V9H0.5V7.5H6ZM9.5 -9.53674e-07V4H13.5V5.5H8V-9.53674e-07H9.5Z"
				fill="white"
			/>
		</svg>
	)
}

export default CloseWidthImage
